import api from 'core/api';

export const getContract = (name) => api.get(`/fine_print/contract/${name}`);
export const getUserSign = (name) => api.get(`/fine_print/contract/${name}/user_sign`);
export const acceptContract = (data) => api.post('/fine_print/accept_contract', data);
export const rejectContract = (data) => api.post('/fine_print/reject_contract', data);
